// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.4142 2H3V7.5H11.4142L13.4142 9.5H19.4277L21.4277 4H13.4142L11.4142 2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.4277 11.5H12.5858L10.5858 9.5H3V22.5H5V15H10.5858L12.5858 17H21.4277L19.4277 11.5Z"}}]};

const Flag1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'flag-1-filled',
    ref,
    icon: element,
  },
));

Flag1FilledIcon.displayName = 'Flag1FilledIcon';

export default Flag1FilledIcon;
